// Store + external links surfaced on the landing page.
// APP_STORE_URL is live (the app record exists under this Apple ID).
// CHROME_STORE_URL is filled in once the Chrome Web Store item is published.
// FIREFOX_STORE_URL is filled in once the addons.mozilla.org listing is live.

export const APP_STORE_URL = "https://apps.apple.com/app/id6477404511";
export const CHROME_STORE_URL = "https://chromewebstore.google.com/detail/dfijieibikhpelmfhkjmihgfgpoeigch";
export const FIREFOX_STORE_URL = "https://addons.mozilla.org/en-US/firefox/addon/web-time-machine/";

export const GITHUB_URL = "https://github.com/webtimemachine/wtm3";
export const PRIVACY_URL = "/privacy";
